module.exports = __webpack_public_path__ + "media/src/website/images/locations/eggstaett/eggstaett_01-b6a94ce2aa4bd973d0f812ac823d2f82.jpg";